// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__18gf9","notes":"Notes_notes__LD5uj"};